@use '@flixbus/honeycomb-react/dist/scss/honeycomb-helpers.scss';

.filterContainer {
  width: 100%;
  padding-top: var(--hcr-spacing-6);
}

.filterGrid {
  width: 100%;
}

.filterActionsGrid {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  width: 100%;
  min-height: 100%;
}

// Makes SelectGroup buttons equal width, mirrors CPC pattern
.statusSelectGroup {
  flex: 1;

  > ul {
    width: 100%;

    > li {
      flex-grow: 1;

      > input {
        width: 0;
      }
    }
  }
}
